import { render, staticRenderFns } from "./ButtonPlusMinus.vue?vue&type=template&id=fa038d5e&"
import script from "./ButtonPlusMinus.vue?vue&type=script&lang=js&"
export * from "./ButtonPlusMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports